import { ActionTypes } from "../constants/action-types";

const initialState = {
    selected: "null"
}
export const menuReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.CHANGE_MENU_SELECTION:
            return { ...state, selected: payload};
        default:
            return state    
    }
}